import type { Cache, ResolveInfo } from '@urql/exchange-graphcache';
import { EVENT_PERSON_CACHE_FIELDS } from '@/client/exchanges/cacheExchange/constants';
import invalidateFields from '@/client/exchanges/cacheExchange/invalidateFields';

export default function delete_event_person_by_pk(
  _parent: unknown,
  _args: unknown,
  cache: Cache,
  _info: ResolveInfo,
) {
  invalidateFields(EVENT_PERSON_CACHE_FIELDS, cache);
}
